module.exports = __webpack_public_path__ + "static/media/himatek_itdel_logo.f2b6179a.png";